import {
  AgencyTaskSchema,
  PostAttachmentSchema,
  PostPlatformSchema,
  PostSchema,
} from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { postsKeys } from './keys';

export function useUpdatePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Partial<PostSchema> & { id: string }) => {
      return apiClient.patch<
        ApiResponse<{
          post: PostSchema;
          postPlatforms: PostPlatformSchema[];
          postTasks: AgencyTaskSchema[];
          postAttachments: PostAttachmentSchema[];
        }>
      >(`/v1/posts/${params.id}`, params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: postsKeys.all });
    },
  });
}
